import React from 'react';
import { Loader2, ShoppingCart } from 'lucide-react';

const AnalysisEbayResultsSection = ({ ebayLoading, ebayResults }) => {
  if (!ebayLoading && !ebayResults) {
    return null;
  }

  return (
    <div className="mt-4 sm:mt-6 border-t border-slate-200 pt-4">
      <div className="flex items-center gap-2 mb-3">
        <ShoppingCart size={18} className="text-blue-600" />
        <h4 className="text-base sm:text-lg font-semibold text-slate-800">Similar Items on eBay</h4>
        {ebayLoading && <Loader2 size={16} className="animate-spin text-blue-500" />}
      </div>

      {ebayLoading && !ebayResults && (
        <p className="text-sm text-slate-500 italic">Searching eBay for similar items...</p>
      )}
      {ebayResults && ebayResults.length === 0 && (
        <p className="text-sm text-slate-500 italic">No similar items found on eBay.</p>
      )}
      {ebayResults && ebayResults.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {ebayResults.map((ebayItem, idx) => (
            <a
              key={ebayItem.itemId || idx}
              href={ebayItem.itemWebUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-white border border-slate-200 rounded-lg overflow-hidden hover:shadow-md hover:border-blue-300 transition-all group"
            >
              {ebayItem.image && (
                <div className="aspect-square bg-slate-100 overflow-hidden">
                  <img src={ebayItem.image} alt={ebayItem.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform" />
                </div>
              )}
              <div className="p-2">
                <p className="text-xs font-medium text-slate-700 line-clamp-2 mb-1">{ebayItem.title}</p>
                <p className="text-sm font-bold text-green-600">${ebayItem.price} {ebayItem.currency}</p>
                {ebayItem.condition && (
                  <p className="text-[10px] text-slate-400 mt-0.5">{ebayItem.condition}</p>
                )}
              </div>
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default AnalysisEbayResultsSection;
